import React from 'react';

import { IconProps } from './types';

const HistoryIcon: React.FC<IconProps> = props => {
  const { width = '18', height = '18', fillColor = '#0276FE' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <path
        fill={fillColor}
        d="M9 18c-2.1 0-3.958-.637-5.575-1.913C1.808 14.813.758 13.183.275 11.2a.741.741 0 0 1 .15-.688.974.974 0 0 1 .675-.362c.267-.033.508.017.725.15.217.133.367.333.45.6.4 1.5 1.225 2.725 2.475 3.675C6 15.525 7.417 16 9 16c1.95 0 3.604-.68 4.963-2.037C15.32 12.604 16 10.95 16 9c0-1.95-.68-3.604-2.037-4.963C12.604 2.68 10.95 2 9 2a6.75 6.75 0 0 0-3.225.8A7.431 7.431 0 0 0 3.25 5H5c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.968.968 0 0 1 5 7H1a.968.968 0 0 1-.713-.287A.968.968 0 0 1 0 6V2c0-.283.096-.52.287-.712A.968.968 0 0 1 1 1c.283 0 .52.096.712.288.192.191.288.429.288.712v1.35A8.732 8.732 0 0 1 5.112.875 8.93 8.93 0 0 1 9 0c1.25 0 2.42.237 3.512.713a9.147 9.147 0 0 1 2.85 1.925 9.149 9.149 0 0 1 1.926 2.85A8.707 8.707 0 0 1 18 9c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.926A8.707 8.707 0 0 1 9 18Zm1-9.4 2.5 2.5a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275L8.3 9.7a.999.999 0 0 1-.225-.337A1.034 1.034 0 0 1 8 8.975V5c0-.283.096-.52.287-.713A.968.968 0 0 1 9 4c.283 0 .52.096.713.287.191.192.287.43.287.713v3.6Z"
      />
    </svg>
  );
};

export default HistoryIcon;
